<mat-card-header>
  <mat-card-title>Modifications</mat-card-title>
</mat-card-header>
<mat-card-content>
  @if (loaded) {
  <table
    mat-table
    matSort
    #logTableComp
    [dataSource]="logTable.data"
    class="mat-elevation-z8"
    aria-describedby="logs of audtis">
    @for (col of logTable.col; track col) {
    <ng-container [matColumnDef]="col.field">
      <th
        id="table"
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header>
        {{ col.title }}
      </th>
      <td
        mat-cell
        *matCellDef="let recommendation">
        {{ recommendation[col.field] }}
      </td>
    </ng-container>
    }
    <tr
      mat-header-row
      *matHeaderRowDef="colFields(logTable.col)"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: colFields(logTable.col)"
      class="item"></tr>
  </table>
  }
</mat-card-content>
